import { render } from "./ExampleText.vue?vue&type=template&id=78aa0ac6"
import script from "./ExampleText.vue?vue&type=script&lang=ts"
export * from "./ExampleText.vue?vue&type=script&lang=ts"
script.render = render

export default script